import React, { Component } from 'react';
import './content-left-top-title.css';
import RequestSample from '../../../../Forms/request-sample/request-sample';
import ContentLeftTopSkelton from './content-left-top-title-skelton';
import default_img from '../../../../img/download.png';
import noImageAvailable from '../../../../img/noImageAvailable330.png';

class ContentLeftTopTitle extends Component {
    constructor(props,context) {
        super(props, context);

        this.state = {
            smShow: false,
            lgShow: false,
            isLoaded:false,
            data:  this.props.data_title.data
        };

    }
    render() {
        let lgClose = () => this.setState({ lgShow: false });
        let title,title_tooltip;
        if(this.state.data.data.title != undefined)
        {
            title = this.state.data.data.title.length >=70 ? this.state.data.data.title.substring(0,70)+" ..." : this.state.data.data.title,
                title_tooltip = this.state.data.data.title.length>=70 ? this.state.data.data.title : ''
        }

        const {error,isLoaded} = this.props.data_title.data;
        let img_url = 'https://mordorintelligence.com:81/admin-345336admin/images_db/';
        const DEFAULT_IMG = default_img;
        if (!isLoaded) {
            return <ContentLeftTopSkelton />;
        } else {
            return (
                <div class="row">
                    <div class="col-md-12">
                        <div class="reportd_pic">
                            <img src={'https://mordorintelligence.com:81'+this.state.data.data.picture_url}
                                 data-src={'https://mordorintelligence.com:81'+this.state.data.data.picture_url}
                                 class="img-responsive"
                                 onError={(e)=>{e.target.src=noImageAvailable}}
                                 alt={this.state.data.data.title}/>
                        </div>
                        <div class="reportd_title">
				<span>Published

					<p className="p_font_size">
                      {this.state.data.data.published_year}
                    </p>
				</span>
                            <h1 title={title_tooltip}>{this.state.data.data.title}</h1>
                            <button class="spk_ana open-AddBookDialog btn_bg hidden-xs" id="d2"
                                    onClick={() => this.setState({lgShow: true})} data-id={this.state.data.data.title}>
                                <i class="fa fa-download"></i>Download Free Sample NOW
                            </button>
                        </div>
                        <div>
                            <button class="spk_ana open-AddBookDialog btn_bg open-AddBookDialog_title_pt visible-xs" id="d2"
                                    onClick={() => this.setState({lgShow: true})} data-id={this.state.data.data.title}>
                                <i class="fa fa-download"></i> Download Free Sample NOW
                            </button>
                        </div>
                    </div>
                    <RequestSample show={this.state.lgShow} data={this.state.data} onHide={lgClose}/>
                </div>
            );
        }
    }


}


export default ContentLeftTopTitle;


// WEBPACK FOOTER //
// ./src/report-description/content/content-left/content-left-top-title/content-left-top-title.js